import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "@/app/store";
import { RootState } from "@/app/rootReducer";
import { useNotification } from "@/context/NotificationContext";
import { purgeInvoicesAction } from "../slices/purgeInvoicesSlice";

export const usePurgeInvoices = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { showNotification } = useNotification();

  const { purgeLoading, purgeError } = useSelector(
    (state: RootState) => state.purgeInvoices,
  );

  const handlePurgeInvoices = useCallback(
    async (intacctId: string) => {
      try {
        await dispatch(purgeInvoicesAction(intacctId));

        showNotification(
          "Successfully purged invoices!",
          "All imported invoices have been successfully purged",
          "success",
        );
      } catch (error) {
        showNotification(
          "Failed to purge invoices",
          purgeError || "An error occurred while purging invoices",
          "error",
        );
      }
    },
    [dispatch, showNotification, purgeError],
  );

  return {
    handlePurgeInvoices,
    purgeLoading,
    purgeError,
  };
};
